export default __webpack_public_path__ + "static/CreditCard_Option2_50673758-eced5ee589913cec94e8a83398c0e9f7.png";